<div class="wrapper-bundle-items-table" [class.without-prices]="!arePricesVisible()">
  <span class="col-header-1">Menge</span>
  <span class="col-header-2">Artikel</span>
  <span class="col-header-3">Preis je VE</span>
  <span class="col-header-4">Summe VE</span>

  @for (item of paidProducts(); track item) {
    <div class="grid-row-wrapper" [class.with-retail-unit-deposit]="item.prices?.salesUnitDeposit">
      <span class="col-1">{{ item.quantity }}</span>
      <span class="col-2">{{ item.details.name }}</span>
      <span class="col-3">
        @if (item.prices; as prices) {
          <ui-product-prices-formatter
            [price]="prices.salesUnit"
          ></ui-product-prices-formatter>
        }
      </span>

      <span class="col-4">
          @if (item.prices; as prices) {
            <ui-product-prices-formatter
              [price]="item.quantity * prices.salesUnit">
            </ui-product-prices-formatter>
          }
      </span>

      @if (arePricesVisible() && item.prices?.salesUnitDeposit && item.prices!.salesUnitDeposit! > 0) {
        <ng-container *ngTemplateOutlet="depositTemplate, context: { item, isFree: false }"></ng-container>
      }
    </div>
  }

  @for (item of freeProducts(); track item) {
    <div class="grid-row-wrapper free-items-row-wrapper" [class.with-retail-unit-deposit]="item.prices?.salesUnitDeposit">
      <span class="col-1">{{ item.quantity }}</span>
      <span class="col-2">{{ item.details.name }}</span>
      <span class="col-3 free-label">GRATIS</span>
      <span class="col-4">-</span>

      @if (arePricesVisible() && item.prices?.salesUnitDeposit && item.prices!.salesUnitDeposit! > 0) {
        <ng-container *ngTemplateOutlet="depositTemplate, context: { item, isFree: true }"></ng-container>
      }
    </div>
  }

  @if (bundleType() === 'reimbursement' && bundlePrices(); as prices) {
    <div class="grid-row-wrapper free-items-row-wrapper">
      <span class="col-1">{{ 1 }}</span>
      <span class="col-2">Vergütung</span>
      <span class="col-3 free-label">
        <ui-product-prices-formatter
          [price]="prices.salesUnit"
        >
        </ui-product-prices-formatter></span>

      <span class="col-4">-</span>
    </div>
  }

</div>

<div class="wrapper-sums">
  @if (arePricesVisible()) {
    @if (bundlePrices()?.bundlePrice; as bundlePrice) {
      <div class="wrapper-sum">
        <span>Summe | Paket</span>
        <ui-product-prices-formatter [price]="bundlePrice"></ui-product-prices-formatter>
      </div>
    }

    @if (sumRetailUnitDeposit() > 0) {
      <div class="wrapper-retail-unit-deposit">
        <span>zzgl. Pfand</span>
        <ui-product-prices-formatter [price]="sumRetailUnitDeposit()"></ui-product-prices-formatter>
      </div>
    }
  }
</div>

<ng-template let-item="item" let-isFree="isFree" #depositTemplate>
  <div class="grid-row-wrapper deposit-row-wrapper" [class.free-items-row-wrapper]="isFree">
    <span class="col-1"></span>
    <span class="col-2">zzgl. Pfand</span>
    <span class="col-3">
      <ui-product-prices-formatter
        [price]="item.prices.salesUnitDeposit"
      ></ui-product-prices-formatter>
    </span>
    <span class="col-4">
        <ui-product-prices-formatter
          [price]="item.quantity * item.prices.salesUnitDeposit"
        ></ui-product-prices-formatter>
      </span>
  </div>
</ng-template>
